import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useAppEventsApi } from '../../../../services/api/appEventsApi/useAppEventsApi';
import { APP_EVENT_TYPE } from '../../app-events-aggregator';
import { gtmTracker } from '../../gtmTracker';
import { TRACER_STATUS_CODE } from '../../tracer/utils/tracerStatusCode';
import { useChatAgentTracer } from './useChatAgentTracer';

export const useChatAgentMessagesTracer = register => {
    const { startTrace, addTraceAttributes, getTraceHeaders, endTrace } = useChatAgentTracer();
    const { sendEventList } = useAppEventsApi();

    useEffect(() => {
        const unregister = register(async event => {
            const shouldTrace =
                !isEmpty(event?.event?.triggerName) || event?.event?.type === APP_EVENT_TYPE.CHAT_DIALOG_MESSAGE;
            event.__skip_app_event = false;

            if (!shouldTrace) {
                return;
            }

            startTrace({ event });
            const headers = getTraceHeaders();
            const traceParent = headers?.traceparent;

            if (!traceParent) {
                return;
            }

            event.traceParent = traceParent;
            event.__skip_app_event = true;

            try {
                await sendEventList([event], headers);
            } catch (err) {
                addTraceAttributes({ 'error.message': err.message });
                endTrace(TRACER_STATUS_CODE.ERROR, err.message);
                gtmTracker.trackError(`Failed to send traced event ${event.id}: ${err}`);
            }
        });

        return unregister;
    }, [addTraceAttributes, endTrace, getTraceHeaders, register, sendEventList, startTrace]);
};
